import { render, staticRenderFns } from "./UkrTreasuresTable.vue?vue&type=template&id=4a71f5a9&scoped=true"
import script from "./UkrTreasuresTable.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresTable.vue?vue&type=script&lang=js"
import style0 from "./UkrTreasuresTable.vue?vue&type=style&index=0&id=4a71f5a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71f5a9",
  null
  
)

export default component.exports